/** @format */

export * from './product-card-color-swatches.module';
